export const fbAppId = process.env.REACT_APP_FB_APP_ID;
export const fbSdkVersion = process.env.REACT_APP_FB_SDK_VERSION;

export const tokenNames = Object.freeze({
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
} as const);

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
